import {TrinityEvents} from './trinity.js';
import JshModule from '@core/scripts/helper/jsh-module';
import WindowManager from '@core/scripts/components/window-manager.js';
import meta from '@core/scripts/helper/meta.js';

const {config} = JshModule('teaser/flowbox-teaser');

const loadingEl = document.querySelector(`#flowbox_loading_${config.entryId}`);

function showLoading() {
    if (loadingEl) loadingEl.removeAttribute('hidden');
}

function hideLoading() {
    if (loadingEl) loadingEl.setAttribute('hidden', '');
}

function waitForFlowboxImages(container) {
    return new Promise(resolve => {
        const poll = setInterval(() => {
            const shadowRoot = container.shadowRoot;
            const imgCount = shadowRoot ? shadowRoot.querySelectorAll('img[src]').length : 0;
            if (imgCount > 0) {
                clearInterval(poll);
                resolve();
            }
        }, 200);

        // Safety fallback
        setTimeout(() => { clearInterval(poll); resolve(); }, 10000);
    });
}

function updateFlow(tag, tagsOperator) {
    showLoading();
    window.flowbox('update', {
        key: config.flowboxKey,
        tags: Array.isArray(tag) ? tag : [tag],
        tagsOperator: tagsOperator
    });
    const container = document.querySelector(`#flowbox_content_${config.entryId}`);
    if (container) waitForFlowboxImages(container).then(hideLoading);
}

function clearButtonClasses(buttons) {
    for (const button of buttons) {
        button.classList.remove('flowbox-tag-active');
    }
}

function waitFor(condition, timeout) {
  return new Promise(resolve => {
    const interval = setInterval(() => {
      if (condition()) {
        clearInterval(interval);
        resolve();

      }
    }, timeout)
  })
}

function init() {
  // Intercept Flowbox API calls to use our caching proxy
  if (!window.__flowboxFetchPatched) {
    const originalFetch = window.fetch;
    window.fetch = function(url, options) {
      if (typeof url === 'string' && url.includes('gateway.getflowbox.com/v2/public/feed/')) {
        url = url.replace('https://gateway.getflowbox.com/v2/public/feed/', meta.value('bonprix:baseUrl') + 'ajax/flowbox/');
      }
      return originalFetch.call(this, url, options);
    };
    window.__flowboxFetchPatched = true;
  }

  (function (d, id) {
    if (!window.flowbox) {
      var f = function () {
        f.q.push(arguments);
      };
      f.q = [];
      window.flowbox = f;
    }
    if (d.getElementById(id)) {
      return;
    }
    var s = d.createElement('script'), fjs = d.scripts[d.scripts.length - 1];
    s.id = id;
    s.async = true;
    s.src = 'https://connect.getflowbox.com/flowbox.js';
    fjs.parentNode.insertBefore(s, fjs);
  })(document, 'flowbox-js-embed');

    var allTags = [];
    for (var i = 1; i < document.querySelectorAll('button[data-tag]').length; i++) {
        allTags.push(document.querySelectorAll('button[data-tag]')[i].dataset.tag);
    }

    var configTags = config.tags
        ? config.tags.replace(/^\[|]$/g, '').split(',').map(t => t.trim()).filter(Boolean)
        : null;

    window.flowbox('init', {
    container: `#flowbox_content_${config.entryId}`,
    key: config.flowboxKey,
    locale: config.locale,
    productId: config.productId,
        tags: configTags || allTags,
    allowCookies: false
  });

    const buttons = document.querySelectorAll('button[data-tag]');

    document.addEventListener('click', function(event) {
        if (event.target.matches('div.tags button')) {
            if (event.target.dataset.tag == '') {
                updateFlow(allTags, 'any');
            } else {
                updateFlow(event.target.dataset.tag, 'all');
            }
            clearButtonClasses(buttons);
            event.target.classList.add('flowbox-tag-active');
        }
    }, false);


  const observer = new IntersectionObserver((entries) => {
    entries.forEach(async (entry) => {
      if (entry.isIntersecting) {
        observer.disconnect();
        await triggerPostprocessing(postProcessor);
      }
    })
  })
  observer.observe(document.querySelector(`#flowbox_content_${config.entryId}`));
}

async function triggerPostprocessing(postProcessor) {
  const container = document.querySelector(`#flowbox_content_${config.entryId}`);
  if (container) await waitForFlowboxImages(container);
  hideLoading();
  postProcessor?.()
}

function getFunctionIdForPage(pageName) {
  switch (pageName) {
    case 'home':
      return 22;
    case 'trend':
      return 25;
    case 'canal':
      return 24;
  }
}

function getPageName(pageName, shopId) {
  if (pageName === 'canal' && shopId === '317433') {
    return 'trend';
  }
  return pageName;
}

function postProcessor() {
  const contentList = document.getElementsByClassName('content-list');
  let pageName = contentList[0].getAttribute(`jsh-tracking__trinityClickPage`);
  const shopId = contentList[0].getAttribute(`jsh-tracking__shopId`);
  pageName = getPageName(pageName, shopId);
  const functionId = getFunctionIdForPage(pageName);

  const flowboxDiv = document.querySelector(`#flowbox_content_${config.entryId}`);
  const shadowRoot = flowboxDiv.shadowRoot;
  const children = shadowRoot ? shadowRoot.querySelectorAll('.flbx-post-media-button') : [];

  TrinityEvents.sendFlowboxTeaserView({
    numberOfPicture: children.length,
    page: pageName
  });
  children.forEach((element, index) => {
    element.onclick = async () => {
      TrinityEvents.sendFlowboxTeaserClick({page: pageName});

      await waitFor(() => shadowRoot?.querySelector('dialog.flbx-post-dialog'), 1000)
      const modal = shadowRoot.querySelector('dialog.flbx-post-dialog');
      modal.onclick = (e) => {
        if (!e.target.closest('button.flbx-post-product-button')) return;
        const productContainer = e.target.closest('.flbx-post-standout-product-list-item');
        if (productContainer) {
          const img = productContainer.querySelector('img.flbx-post-product-picture');
          const itemNumberMatch = img?.src?.match(/\/(\d{6,9})-/);
          WindowManager.setSpecificTabDataItem("pointOfSaleId", functionId);
          if (itemNumberMatch) {
            const itemNumber = parseInt(itemNumberMatch[1], 10);
            TrinityEvents.sendFlowboxTeaserLayerClick({
                itemNo: itemNumber,
                page: pageName,
                functionId: functionId
            });
          }
        }
      }
    }
  })
}


init();
